import React from 'react';
import PropTypes from 'prop-types';
import { Title } from 'smartsuite-ui';
import useLink from '../../../../shared/hooks/linkHooks';
import TextOrLinkTitle from '../../../../shared/TextOrLinkTitle';

function buildChartClassName(hasChart, baseClassName) {
    return hasChart
        ? baseClassName
        : `${baseClassName} ${baseClassName}--no-chart`;
}

export default function MultiChartComponent(props) {
    const { groupByValue, metrics, metricRequests, ...remainingProps } = props;
    const { chartTypeConfiguration } = props.configuration;

    const headerLink = useLink(
        props.configuration.linkConfig,
        metricRequests[0],
        metrics[0].metricSeries[0]
    );

    const metricRequestsWithFirstGroupRemoved = props.metricRequests.map(
        (metricRequest) => ({
            ...metricRequest,
            groupBy: metricRequest.groupBy.slice(1),
        })
    );

    const chartClassName = buildChartClassName(
        chartTypeConfiguration.hasChart,
        'multi-chart-container__chart'
    );

    const chartBodyClassName = buildChartClassName(
        chartTypeConfiguration.hasChart,
        'multi-chart-container__chart-body'
    );

    const chartStyles = {
        textAlign: props.configuration.textAlign || 'inherit',
        ...props.configuration.widgetProperties.containerStyles,
    };

    return (
        <div key={groupByValue} className={chartClassName} style={chartStyles}>
            <Title cssClassModifiers={['size-medium']}>
                <TextOrLinkTitle
                    navigationLink={headerLink}
                    openLinkInNewTab={props.openLinksInNewTab}
                    title={groupByValue}
                />
            </Title>
            <div className={chartBodyClassName}>
                {chartTypeConfiguration.render({
                    ...remainingProps,
                    key: groupByValue,
                    metrics,
                    metricRequests: metricRequestsWithFirstGroupRemoved,
                    configuration: {
                        ...chartTypeConfiguration,
                        ...chartTypeConfiguration.widgetProperties,
                    },
                })}
            </div>
        </div>
    );
}

MultiChartComponent.propTypes = {
    configuration: PropTypes.instanceOf(Object).isRequired,
    groupByValue: PropTypes.string.isRequired,
    metrics: PropTypes.instanceOf(Array).isRequired,
    metricRequests: PropTypes.instanceOf(Array).isRequired,
    openLinksInNewTab: PropTypes.bool,
};
